
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import Nullable from '@/types/nullable';
import moment from 'moment';
import EmailServiceForm from '@/components/jobDetail/EmailServiceForm.vue';

@Component({
  components: {
    EmailServiceForm
  }
})
export default class JobContact extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;
  private showSendEmail: boolean = false;

  get jobCommenced(){
    return moment(this.job.firstCommencedAt).format('DD MMM YYYY');
  }

  get jobComplete(){
    return moment(this.job.lastFinishedAt).format('DD MMM YYYY');
  }

  get contactEmail(){
    return this.job.client.location.contactEmail;
  }

  viewServiceForm(){
    this.$router.push({ name: 'viewjobserviceform', params: { jobID: this.job.id } });
  }
}

